<form [formGroup]="employmentForm" #ngForm="ngForm" class="form">
  <div class="checkbox-container">
    <input
      (change)="onOnSiteChange()"
      formControlName="onSite"
      type="checkbox"
      id="onSite"
    />
    <label class="label" for="onSite">{{ 'label.OnSite' | translate }}</label>
    <div class="svgClass">
        <svg-icon src="/assets/icons/onsite-dynamic.svg" svgClass="employment-form-icon"></svg-icon>
    </div>
  </div>
  <div class="checkbox-container">
    <input
      (change)="onWorkFromHomeChange()"
      formControlName="workFromHome"
      type="checkbox"
      id="workFromHome"
    />
    <label class="label" for="workFromHome">{{ 'label.WorkFromHome' | translate }}</label>
    <div class="svgClass">
        <svg-icon src="/assets/icons/home-dynamic.svg" svgClass="employment-form-icon"></svg-icon>
    </div>
  </div>
  <div class="checkbox-container">
    <input
      (change)="onHybridChange()"
      formControlName="hybrid"
      type="checkbox"
      id="hybrid"
    />
    <label class="label" for="hybrid">{{ 'label.Hybrid' | translate }}</label>
    <div class="svgClass">
        <svg-icon src="/assets/icons/hybrid-dynamic.svg" svgClass="employment-form-icon"></svg-icon>
    </div>
  </div>

  <div class="checkbox-container">
    <input
      (change)="onMobileFieldChange()"
      formControlName="mobileField"
      type="checkbox"
      id="mobileField"
    />
    <label class="label" for="mobileField">{{ 'label.MobileField' | translate }}</label>
    <div class="svgClass">
        <svg-icon src="/assets/icons/mobile-field-dynamic.svg" svgClass="employment-form-icon"></svg-icon>
    </div>
  </div>
</form>
